<template>

	<b-row>

		<div id="aside" class="col-3" :class="{ active: active}" style="margin-right: 0px;padding: 0px;">

			<b-card bg-variant="white" :header="$t('department.title')" style="min-height: 95%;margin-left: 7px">

				<ul v-if="getDepartments.length > 0">
					<template v-for="dep in getDepartments">
						<tree-view-employee
							class="itemLocal"
							:key="dep.id + 'dep'"
							:model="dep">
						</tree-view-employee>
					</template>
				</ul>
				<!--<p>{{this.getReferenceChildren}}</p>-->
			</b-card>
		</div>

		<div v-bind:class="{'col-12': !active,  'col-9': active,'col9': active}">

			<transition name="slide">

				<b-card :header="caption" style="min-height: 95%;overflow: hidden; margin-right: 5px">

					<div slot="header">
						<span>
							<span class="fa fa-bars" style="font-size:12px;cursor: pointer"
								  @click="toggleNav()"></span>
						</span>

						<span style="font-size:12px; padding: 6px">{{ $t('employees.title') }}</span>
						<span style="font-size:12px;padding: 1px">{{getCurrentName}}</span>

						<div class="card-header-actions">
							<div class="searchInCard" style="margin: -4px">
								<b-input-group style="padding-right: 5px" size="sm">
									<b-form-input v-model="filter" size="sm" :placeholder="$t('contragent.search')"/>
									<b-input-group-append>
										<b-button :disabled="!filter" @click="filter = ''">{{$t('contragent.clear')}}

										</b-button>
									</b-input-group-append>
								</b-input-group>
							</div>
							<b-link @click="showCreateEmployeeModal({})"
									v-if="$can('create/edit', 'employee')"
									class="card-header-action btn-setting"
									style="font-size: 15px">
								<i class="fa fa-plus-circle"></i>
							</b-link>

							<vs-dropdown vs-custom-content vs-trigger-click>
								<b-link href.prevent class="card-header-action btn-setting" style="font-size: 15px">
									<i class="fa fa-th"></i>
								</b-link>
								<vs-dropdown-menu class="columns-dropdown">
									<visible-columns :default-fields="computedField"
													 @result="columnListener"></visible-columns>
								</vs-dropdown-menu>
							</vs-dropdown>


						</div>
					</div>
					<div style="height: 94%">
						<b-table style="margin-left:-6px;margin-right: -8px;white-space: nowrap"
								 class="generalTableClass" :hover="hover"
								 :filter="filter"
								 :striped="striped" :bordered="bordered"
								 :small="small"
								 responsive :items="getemployees.items" :fields="emptyArray"
								 :fixed="fixed"
								 :current-page="currentPage"
								 :per-page="0" show-empty>

							<template slot="fullName" slot-scope="data">
								<strong>{{data.item.firstName}} {{ data.item.lastName }}
									{{data.item.middleName}}</strong>
							</template>
							<template slot="address" slot-scope="data">
								<strong>{{data.item.address}} {{ data.item.address2 }}</strong>
							</template>

							<template slot="department" slot-scope="data">
								<strong>{{data.item.department}}</strong>
							</template>

							<template slot="positionName" slot-scope="data">
								<strong>{{data.item.positionName}}</strong>
							</template>
							<template slot="department" slot-scope="data">
								<strong>{{data.item.gender}}</strong>
							</template>

							<template slot="phone" slot-scope="data">
								<strong>{{data.item.phone}} {{ data.item.mobile }}</strong>
							</template>
							<template slot="gender" slot-scope="data">
								<strong>{{data.item.gender=='MALE'?
									$t('employees.create.male'):$t('employees.create.female')}} </strong>
							</template>


							<template slot="actions" slot-scope="data">


								<b-link :key="data.item.id + 'delete'"
										@click="onOpen(data.item.id)"
										:id="'popOverDelete'+data.item.id"
										v-if="$can('delete', 'employee')">
									<i class="fa fa-trash"></i>
								</b-link>

								<b-popover
									:key="data.item.id + 'popover'"
									:target="'popOverDelete'+data.item.id"
									placement="auto"
									container="myContainer"
									:ref="'popover'+data.item.id"
									class="refDeleteConfirm"
								>
									<template slot="title">
										<b-button @click="onClose(data.item.id)" class="close"
												  aria-label="Close"
												  style="margin-left: 5px">
											<span class="d-inline-block" aria-hidden="true">&times;</span>
										</b-button>
										{{$t('want_to_delete?')}}
									</template>
									<div>

										<div class="row mt-1">
											<div class="col-6">
												<b-button variant="outline-danger" size="sm" block
														  @click="onClose(data.item.id)">Yo'q
												</b-button>
											</div>
											<div class="col-6">
												<b-button variant="outline-success" size="sm" block
														  @click="onOk(data.item.id)">Ha
												</b-button>
											</div>
										</div>
									</div>
								</b-popover>

								<b-link v-b-tooltip.hover
										:title="$t('employees.update')" @click="showCreateEmployeeModal(data)"
										v-if="$can('create/edit', 'employee')">
									<i class="fa fa-edit" style="position: absolute"></i>
								</b-link>

							</template>

							<template slot="empty" slot-scope="scope">
								<h4>{{$t('empty')}}</h4>
							</template>

						</b-table>
					</div>
					<div>
						<nav>
							<b-pagination size="sm" :total-rows="total" :per-page="perPage"
										  v-model="currentPage" :prev-text="$t('pagination.prev')"
										  :next-text="$t('pagination.next')"
										  hide-goto-end-buttons
										  @click="pagTest(currentPage)"/>
						</nav>
					</div>


					<b-modal body-class="refModal" size="lg" v-model="createModal" hide-footer ok-title="Save"
							 :title="modalForAdding ? $t('employees.create.add') : $t('employees.create.update')">
						<p v-if="employeeInputNotFilled" style="color: red;">{{$t('please-title')}}</p>
						<b-alert
							v-if="createError"
							:show="dismissCountDown"
							dismissible
							style="margin-bottom: 10px;"
							variant="warning"
							size="sm"
							@dismissed="dismissCountDown=0"
							@dismiss-count-down="countDownChanged"
						>
							<p v-for="(message, index) in createEmployeeErrorMessage"
							   :key="'message'+index">
								{{ $t( message ) }}
							</p>
						</b-alert>
						<div v-if="createModal">

							<div class="row top">
								<div class="col-sm-4">

									<b-form-group
										label-size="sm"
										label-for="refName"
										class="required"
									>
										<label class="lebeltop">{{$t('employees.create.first-name')}}</label>

										<b-form-input style="width: 100%"
													  :placeholder="$t('employees.create.first-name')" size="sm"
													  type="text"
													  id="firstName"
													  v-model="itemLocal.firstName"/>
									</b-form-group>
								</div>
								<div class="col-sm-4">
									<b-form-group
										label-size="sm"
										class="required"
										label-for="lastName">
										<label class="lebeltop">{{$t('employees.create.last-name')}}</label>

										<b-form-input size="sm" :placeholder="$t('employees.create.last-name')"
													  type="text"
													  id="lastName"
													  v-model="itemLocal.lastName"/>
									</b-form-group>
								</div>
								<div class="col-sm-4">
									<b-form-group
										label-size="sm"
										label-for="refName">
										<label class="lebeltop">{{$t('employees.create.middle-name')}}</label>
										<b-form-input size="sm" :placeholder="$t('employees.create.middle-name')"
													  type="text"
													  id="middleName"
													  v-model="itemLocal.middleName"/>
									</b-form-group>
								</div>
							</div>
							<div class="row top">
								<div class="col-sm-4">
									<label class="lebeltop">{{$t('employees.create.position')}}</label>
									<b-form-select v-model="itemLocal.positionId"
												   :plain="false"
												   :options="dropdowns.position.items"
												   size="sm"
												   label-for="Position"
												   :required="true"
												   :text-field="'name'"
												   :value-field="'id'"
												   @reload="loadSubPosition"
									>
										<template slot="first">
											<option :value="null" disabled>
												--{{$t('employees.create.select-position')}}--
											</option>
										</template>
									</b-form-select>
								</div>

								<div class="col-sm-4">
									<b-form-group
										label-size="sm"
										label-for="mobile">
										<label class="lebeltop">{{$t('employees.create.mobile')}}</label>
										<b-form-input size="sm" :placeholder="$t('employees.create.mobile')"
													  type="text"
													  id="mobile"
													  v-model="itemLocal.mobile"/>
									</b-form-group>
								</div>
								<div class="col-sm-4">
									<b-form-group
										label-size="sm"
										label-for="Phone">
										<label class="lebeltop">{{$t('employees.create.phone')}}</label>
										<b-form-input size="sm" :placeholder="$t('employees.create.phone')" type="text"
													  id="Phone"
													  v-model="itemLocal.phone"/>
									</b-form-group>
								</div>

							</div>
							<div class="row top">
								<div class="col-sm-4">
									<b-form-group
										label-size="sm"
										label-for="Email"
									>

										<label class="lebeltop">{{$t('employees.create.email')}}</label>
										<b-form-input size="sm" :placeholder="$t('employees.create.email')" type="text"
													  id="Email"
													  v-model="itemLocal.email"/>
									</b-form-group>
								</div>
								<div class="col-sm-4">
									<b-form-group
										style="font-size: 12px;padding-top: 3px"
										id="exampleInputGroup4"
										label-for="refCode"
										class="required"
									>
										<label class="lebeltop">{{$t('incomes.department')}}</label>
										<multiselect v-model="itemLocal.departmentId"
													 :options="dropDowns.product.items"
													 :searchable="true"
													 :loading="dropDowns.product.loading"
													 :close-on-select="true"
													 label="name"
													 :show-labels="false"
													 track-by="id"
													 @search-change="loadItems($event)"
													 @open="loadItems('')"
													 class="required"
													 :placeholder="$t('incomes.create.select-unit')">

											<template slot="singleLabel" slot-scope="props">
												{{ props.option.name }}
											</template>
											<!--										<template slot="option" slot-scope="option">-->

											<!--											{{option.option.name}} {{option.option.id}}-->
											<!--										</template>-->
										</multiselect>
									</b-form-group>
								</div>
								<div class="col-sm-4">
									<b-form-checkbox v-model="itemLocal.bortProvod" name="bortProvod" switch class="mt-4">
										Бортпроводник
									</b-form-checkbox>
								</div>

							</div>
							<div class="row top">
								<div class="col-sm-4">
									<p v-if="refInputNotFilled" style="color: red;">{{$t('please-title')}}</p>
									<b-form-group
										style="font-size: 12px;padding-top: 3px"
										id="exampleInputGroup3"
										label-for="refCode"
										class="required"
									>
										<label class="lebeltop">{{$t('employees.create.gender')}}</label>
										<b-form-select v-model="itemLocal.gender"
													   :plain="false"
													   size="sm"
													   :required="true"
													   :text-field="'name'"
													   :value-field="'id'"
													   data-errormessage-value-missing="Bu maydon to'ldirilishi shart!">

											<template slot="first">
												<option :value="null" disabled>
													--{{$t('employees.create.select-gender')}}--
												</option>
												<option value="MALE">{{$t('employees.create.male')}}</option>
												<option value="FEMALE">{{$t('employees.create.female')}}</option>
											</template>
										</b-form-select>
									</b-form-group>
								</div>


								<div class="col-sm-4">
									<b-form-group
										label-size="sm"
										label-for="refName"
									>
										<label class="lebeltop">{{$t('employees.create.passport-number')}}</label>
										<b-form-input size="sm" :placeholder="$t('employees.create.passport-number')"
													  type="text"
													  id="passportNumber"
													  v-model="itemLocal.passportNumber"/>
									</b-form-group>
								</div>

								<div class="col-sm-4">
									<b-form-group
										label-size="sm"
										label-for="Inn number">
										<label class="lebeltop">{{$t('employees.create.inn-number')}}</label>

										<b-form-input size="sm" :placeholder="$t('employees.create.inn-number')"
													  type="text"
													  id="taxNumber"
													  v-model="itemLocal.taxNumber"/>
									</b-form-group>
								</div>
							</div>
							<div class="row top">

								<div class="col-sm-4">
									<label class="lebeltop">{{$t('employees.create.citizen')}}</label>

									<b-form-select v-model="itemLocal.citizenId"
												   :plain="false"
												   :options="dropdowns.group.items"
												   size="sm"
												   label-for="Citizen"
												   :required="true"
												   :text-field="'name'"
												   :value-field="'id'"
												   @reload="loadSubCitizen"
									>
										<template slot="first">
											<option :value="null" disabled>--{{$t('employees.create.select-citizen')}}
												--
											</option>
										</template>
									</b-form-select>
								</div>
								<div class="col-sm-4">
									<label class="lebeltop">{{$t('employees.create.hire-date')}}</label>
									<masked-input v-model="itemLocal.hireDate"
												  mask="11-11-1111"
												  class="ml-1 form-control form-control-sm"
												  :placeholder=" $t('employees.create.hire-date')"/>

								</div>

								<div class="col-sm-4">
									<b-form-group
										label-size="sm"
										label-for="dismissDate">
										<!---->
										<label class="lebeltop">{{$t('employees.create.dismiss-date')}}</label>
										<masked-input v-model="itemLocal.dismissDate"
													  mask="11-11-1111"
													  class="ml-1 form-control form-control-sm"
													  :placeholder=" $t('employees.create.dismiss-date')"/>
									</b-form-group>
								</div>

							</div>
							<div class="row top">
								<div class="col-sm-4">
									<label class="lebeltop">{{$t('employees.create.marriage-status')}}</label>
									<b-form-select v-model="itemLocal.marriageStatusId"
												   :plain="false"
												   :options="dropdowns.married.items"
												   size="sm"
												   label-for="MarriageStatusName"
												   :required="true"
												   :text-field="'name'"
												   :value-field="'id'"
												   @reload="loadMarried"
									>
										<template slot="first">
											<option :value="null" disabled>--
												{{$t('employees.create.select-marriage-status')}} --
											</option>
										</template>
									</b-form-select>
								</div>
								<div class="col-sm-4">
									<b-form-group
										label-size="sm"
										label-for="dismissDate">
										<!---->
										<label class="lebeltop">{{$t('employees.create.date-of-birth')}}</label>
										<masked-input v-model="itemLocal.dateOfBirth"
													  mask="11-11-1111"
													  class="ml-1 form-control form-control-sm"
													  :placeholder=" $t('employees.create.date-of-birth')"/>
									</b-form-group>
								</div>
								<div class="col-sm-4">
									<b-form-group
										label-size="sm"
										label-for="children">
										<label class="lebeltop">{{$t('employees.create.children')}}</label>

										<b-form-input size="sm"
													  :placeholder="$t('employees.create.children')"
													  type="text"
													  id="children"
													  v-model="itemLocal.children"/>
									</b-form-group>
								</div>
							</div>
							<div class="row top">
								<div class="col-sm-4">
									<b-form-group label-size="sm" label-for="refPersonnel">
										<label class="lebeltop">Табельный №</label>
										<b-form-input size="sm" placeholder="Табельный №" type="text" id="personnel" v-model="itemLocal.personnel"/>
									</b-form-group>
								</div>
								<div class="col-sm-4">
									<b-form-group label-size="sm" label-for="refPension">
										<label class="lebeltop">Пенсионный №</label>
										<b-form-input size="sm" placeholder="Пенсионный №" type="text" id="pension" v-model="itemLocal.pension"/>
									</b-form-group>
								</div>
								<div class="col-sm-4">
									<b-form-group label-size="sm" label-for="refCard">
										<label class="lebeltop">Карта №</label>
										<b-form-input size="sm" placeholder="Карта №" type="text" id="card" v-model="itemLocal.card"/>
									</b-form-group>
								</div>
							</div>

							<div class="row top">
								<div class="col-sm-6">

									<b-form-group
										label-size="sm"
										label-for="refSort">
										<b-row class="my-1">
											<b-col sm="12">
												<label class="lebeltop">{{$t('employees.create.address')}}</label>
												<b-form-textarea
													id="refSort"
													size="sm"
													type="text"
													v-model="itemLocal.address"
													rows="3"
													max-rows="6"
													:placeholder="$t('employees.create.address')"/>
											</b-col>
										</b-row>
									</b-form-group>

								</div>
								<div class="col-sm-6">
									<b-form-group
										label-size="sm"
										label-for="refSort">
										<b-row class="my-1">
											<b-col sm="12">
												<label class="lebeltop">{{$t('employees.create.address-2')}}</label>
												<b-form-textarea
													size="sm"
													type="text"
													v-model="itemLocal.address2"
													rows="3"
													max-rows="6"
													:placeholder="$t('employees.create.address-2')"/>
											</b-col>
										</b-row>
									</b-form-group>
								</div>

							</div>
							<div class="row top">
								<div class="col-sm-12">
									<b-form-group
										label-size="sm"
										label-for="refComment">
										<label class="lebeltop">{{$t('comment')}}</label>
										<b-form-textarea
											id="refComment"
											size="sm"
											v-model="itemLocal.comment"
											rows="3"
											max-rows="6"
											:placeholder="$t('comment')"/>
									</b-form-group>
								</div>

								<div class="col-sm-7">
									<b-form-group
										style="font-size: 12px;padding-top: 3px"
										id="exampleInputGroup4"
										label-for="refCode"
										class="required"
									>
										<label class="lebeltop">LINKED ID</label>
										<multiselect
												v-model="linkedId"
												:options="employeesNoLinkedIds"
												:searchable="true"
												:custom-label="selectedOption"
												:show-labels="false"
												track-by="id"
												@search-change="loadItemsNoLinkedId($event)"
												@open="loadItemsNoLinkedId('')"
												:placeholder="'LINKD ID'">
										<template>

										</template>
										</multiselect>
									</b-form-group>
								</div>
							</div>
							<div class="row top mt-3 justify-content-end">
								<div class="col-3">
									<b-button variant="outline-danger" size="sm" block
											  @click="closeCreateEmployeeModal">
										{{$t('actions.cancel')}}
									</b-button>
								</div>
								<div class="col-3">
									<b-button variant="outline-success" size="sm" block @click="saveSubmit">
										{{$t('actions.save')}}
									</b-button>
								</div>
							</div>

						</div>

						<div class="row">

						</div>
					</b-modal>

				</b-card>
			</transition>
		</div>
	</b-row>

</template>

<script>
	import {mapGetters, mapActions, mapState} from 'vuex'
	import TreeViewEmployee from './TreeViewEmployee.vue'
	import VisibleColumns from "../../warehouse-management/goods/blocks/VisibleColumns";
	import ReferencesService from "../../../services/references.sevice";
	import MaskedInput from 'vue-masked-input'
	import Multiselect from 'vue-multiselect'
	import EmployeeSerive from "../../../services/employees.service";

	const itemInitial = {
		id: null,
		comment: '',
		departmentName: '',
		departmentId: '',
		dismissDate: '',
		passportNumber: '',
		taxNumber: '',
		firstName: '',
		lastName: '',
		middleName: '',
		gender: null,
		phone: '',
		mobile: '',
		email: '',
		address: '',
		address2: '',
		citizenId: null,
		citizenName: '',
		positionId: null,
		positionName: '',
		marriageStatusId: null,
		marriageStatusName: '',
		hireDate: null,
		children: '',
		dateOfBirth: null,
		dropdowns: {
			group: {
				items: [],
				value: null,
			},

		}


	};
	export default {
		name: "Employees",
		components: {
			TreeViewEmployee,
			VisibleColumns,
			MaskedInput,
			Multiselect

		},
		props: {
			caption: {
				type: String,
				default: 'Employees'
			},
			hover: {
				type: Boolean,
				default: true
			},
			striped: {
				type: Boolean,
				default: true
			},
			bordered: {
				type: Boolean,
				default: false
			},
			small: {
				type: Boolean,
				default: false
			},
			fixed: {
				type: Boolean,
				default: false
			}
		},
		data() {
			return {
				linkedId: null,
				pageNoLinkedId:1,
				limitNoLinkedId:20,
				sendedName: '',
				dropDowns: {
					product: {
						items: [],
						value: null,
						loading: false,
						search: {
							page: 1,
							limit: 100,
							attributes: [{
								field: 'name',
								value: '',
								option: 'CONTAINS'
							}]
						}
					},
				},
				items: [],
				emptyArray: [],
				refField: [],
				dismissCountDown: 4,
				counterForAlert: 0,
				createModal: false,
				employeeInputNotFilled: false,
				modalForAdding: false,
				filter: null,
				active: true,
				activeColor: 'red',
				fontSize: 30,
				activestyle: true,
				col: 'col-12',
				employeeField: [
					{
						key: 'id',
					},
					{
						key: 'fullName',
						label: 'Name'
					},
					{
						key: 'departmentName',
						label: 'Department',
					},


					{
						key: 'gender',
						label: 'Gender',

					},
					{
						key: 'address',
						label: 'Address'
					},

					{
						key: 'phone',
						label: 'Phone'
					},


					{
						key: 'actions',
						'class': 'table_actionsemp'
					}
				],
				tempData: Object.assign({}, itemInitial),
				// itemLocal: Object.assign({}, itemInitial),
				currentPage: 1,
				perPage: 500,
				totalRows: 0,
				dateTime: '',
				hireDate: '',
				dateOfBirth: '',
				citizenName: '',
				refInputNotFilled: false,

				itemLocal: {
					id: null,
					comment: '',
					departmentName: '',
					departmentId: '',
					dismissDate: '',
					hireDate: '',
					dateOfBirth: '',
					passportNumber: '',
					firstName: '',
					lastName: '',
					middleName: '',
					gender: null,
					phone: '',
					mobile: '',
					email: '',
					address: '',
					address2: '',
					citizenId: null,
					positionId: null,
					citizenName: '',
					positionName: '',
					marriageStatusId: null,
					marriageStatusName: '',
					children: '',
					taxNumber: '',
					bortProvod: false
				},
				dropdowns: {
					group: {
						items: [],
						value: null,
					},
					married: {
						items: [],
						value: null,
					},
					position: {
						items: [],
						value: null,
					}
				},


			}
		},
		methods: {
			...mapActions('departments', [
				'getDepartmentsList', 'setCurrentName', 'setCurrentId'
			]),

			...mapActions('employees', [ 'getEmployeNoLinkedId',
				'createEmployee', 'deleteEmployeeStore', 'getDepartmentByEmployeeList', 'getEmployeePagination'
			]),

			onOpen(itemId) {
				let refName = 'popover' + itemId;
				this.$refs[refName].$emit('open')
			},
			loadItems($event) {
				this.dropDowns.product.loading = true;
				this.dropDowns.product.search.attributes[0].value = $event;
				EmployeeSerive.getByDepartmentSearch(this.dropDowns.product.search).then(response => {
					this.dropDowns.product.items = response.data.items;
					this.dropDowns.product.loading = false;
				})


				// else {
				// 	EmployeeSerive.searchEmployee($event).then(response => {
				// 		this.dropDowns.product.items = response.data;
				// 		this.dropDowns.product.loading = false;
				// 	})
				// }

			},

			async loadItemsNoLinkedId($event) {
				this.sendedName = $event
				await this.getEmployeNoLinkedId(this.params)
			},


			onClose(itemId) {
				let refName = 'popover' + itemId;
				this.$refs[refName].$emit('close')
			},
			async employeeDelete(id) {
				await this.deleteEmployeeStore(id);
				let depId = this.getCurrentId;
				let paramsForEmployees = {
					pageLimit: {
						page: this.currentPage,
						limit: this.perPage
					},
					id: depId
				};
				this.getDepartmentByEmployeeList(paramsForEmployees);
				this.getDepartmentsList();

			},
			selectedOption (c) {
				return c.firstName + ' ' + c.lastName + '	' + c.id
			},
			//shu method ni yozdim kn mounted da chaqirdim botton ga click qildim
			toggleNav() {
				this.$parent.$emit('toggleNav')
			},
			isNumber: function (evt) {
				evt = (evt) ? evt : window.event;
				var charCode = (evt.which) ? evt.which : evt.keyCode;
				if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
					evt.preventDefault();

				} else {
					return true;
				}
			},


			async onOk(itemId) {
				this.onClose(itemId)
				await this.employeeDelete(itemId);
			},
			showCreateEmployeeModal(data) {
				if (data.item) {
					// this.itemLocal.departmentId = data.item.departmentId;
					this.tempData = Object.assign({}, data.item);
					this.itemLocal = Object.assign({}, data.item);
					this.itemLocal.departmentId = this.dropDowns.product.items.find(el => {
						return el.id == data.item.departmentId;
					});
					this.linkedId = this.employeesNoLinkedIds.find(el => {
						return el.id == data.item.linkedId;
					});
					this.createModal = true;
					this.modalForAdding = false;
					this.employeeInputNotFilled = false;
				} else {
					this.itemLocal = Object.assign({}, itemInitial);
					this.tempData = Object.assign({}, itemInitial);
					this.createModal = true;
					this.modalForAdding = true;
					this.itemLocal.departmentId = this.dropDowns.product.items.find(el => {
						return el.id == this.getCurrentId;
					});
					this.employeeInputNotFilled = false;
				}
			},
			countDownChanged(dismissCountDown) {
				if (dismissCountDown <= 1) {
					dismissCountDown = 3;
				}
				this.dismissCountDown = dismissCountDown
			},
			async saveSubmit() {
				if (this.itemLocal.gender != null && this.itemLocal.gender != "" && this.itemLocal.lastName != "" && this.itemLocal.firstName != "" && this.itemLocal.departmentId != "") {
					if (this.itemLocal.departmentId != undefined) {
						let depId = this.itemLocal.departmentId.id;
						this.itemLocal.departmentId = depId;
					}
					if(this.linkedId) {
						this.itemLocal.linkedId = this.linkedId.id
					}

					await this.createEmployee(this.itemLocal);
					// this.itemLocal = Object.assign({}, itemInitial);
					let departmentId = this.getCurrentId;
					// this.itemLocal.departmentId = departmentId;
					let paramsForEmployees = {
						pageLimit: {
							page: this.currentPage,
							limit: this.perPage
						},
						id: departmentId
					};

					await this.getDepartmentByEmployeeList(paramsForEmployees);
					await this.getDepartmentsList();
					this.dropdowns.value = null;
					this.createModal = false;

					if (this.createError) {
						setTimeout(() => {
							this.$store.commit('employees/createEmployeeError', {message: [], boolean: false})
						}, 4000)
						this.createModal = true;

					}
				} else {
					this.employeeInputNotFilled = true;
				}

			},
			filterColumns(columns = []) {
				return columns.filter(column => {
					if (column.visible) {
						return column
					}
				})
			},
			columnListener($event) {
				this.emptyArray = this.filterColumns($event)
			},
			async closeCreateEmployeeModal() {
				this.itemLocal = await itemInitial;
				this.employeeInputNotFilled = false;
				this.createModal = false;

			},
			loadSubCitizen() {

				ReferencesService.getReferenceChildren(`Citizen`).then(response => {
					this.dropdowns.group.items = response.data;
				})
			},
			loadSubPosition() {
				ReferencesService.getReferenceChildren(`Position`).then(response => {
					this.dropdowns.position.items = response.data;
				})
			},
			loadMarried() {
				ReferencesService.getReferenceChildren(`Marriage_status`).then(response => {
					this.dropdowns.married.items = response.data;

				})
			},
			async fetchList() {
				const params = {
					page: this.currentPage,
					limit: this.perPage
				};
				await this.getEmployeePagination(params);
				setTimeout(() => {
					this.items = this.$store.state.employees.employeesPage;
				}, 200)
			},

		},


		async created() {
			await this.getDepartmentsList();
			await this.loadItems('');
			await this.loadItemsNoLinkedId(this.params)
		},
		mounted() {
			this.loadSubCitizen();
			this.loadMarried();
			this.loadSubPosition();
			this.emptyArray = this.filterColumns(this.computedField);
			this.$parent.$on('toggleNav', () => {
				this.active = !this.active
			})
		},

		computed: {
			params() {
				return {
					page: this.pageNoLinkedId,
					limit:this.limitNoLinkedId,
					name: this.sendedName
				}
			},
			...mapGetters('departments', [
				'getDepartments', 'getCurrentName', 'getCurrentId'
			]),
			...mapGetters('employees', [
				'getemployees', 'total', 'columns', 'employees', 'getPagination'
			]),
			...mapGetters('references', [
				'getReferences'
			]),
			...mapState('employees', [ 'employeesNoLinkedIds',
				'createError', 'createEmployeeErrorMessage'
			]),
			item: {
				get() {
					return this.itemLocal;
				},
				set(data) {
					this.itemLocal = data;
				}
			},
			computedField() {

				return [
					{
						key: 'id',
						label: 'Id',
						'class': 'min-60',
						visible: true,
						changebale: false
					},
					{
						key: 'fullName',
						label: this.$t('employees.full-name'),
						'class': 'min-200',
						visible: true,
						changebale: true
					},
					{
						key: 'positionName',
						label: this.$t('employees.create.position'),
						'class': 'min-100',
						visible: true,
						changebale: true
					},

					{
						key: 'gender',
						label: this.$t('employees.gender'),
						'class': 'min-100',
						visible: true,
						changebale: true
					},
					{
						key: 'phone',
						'class': 'min-130',
						label: this.$t('employees.phone'),
						visible: true,
						changebale: true
					},
					{
						key: 'dateOfBirth',
						label: this.$t('employees.date-of-birth'),
						'class': 'min-100',
						visible: false,
						changebale: true
					},
					{
						key: 'departmentName',
						'class': 'min-150',
						label: this.$t('employees.departments'),
						visible: true,
						changebale: true
					},
					{
						key: 'address',
						label: this.$t('employees.address'),
						'class': 'min-180',
						visible: false,
						changebale: true
					},
					{
						key: 'citizenName',
						label: this.$t('employees.citizen'),
						'class': 'min-120',
						visible: false,
						changebale: true
					},
					{
						key: 'children',
						label: this.$t('employees.children'),
						'class': 'min-90',
						visible: false,
						changebale: true
					},

					{
						key: 'email',
						label: this.$t('employees.email'),
						'class': 'min-200',
						sortable: true,
						visible: false,
						changebale: true
					},
					{
						key: 'actions',
						label: this.$t('employees.actions'),
						'class': 'table_actions min-60 fixed-col',
						visible: true,
						changebale: false
					}

				]
			}
		},

		watch: {
			'dropdowns.group.value': {
				handler() {
					if (this.dropdowns.value)
						return;
					this.dropdowns.group.items.map((citizen) => {
						if (citizen.id === this.dropdowns.group.value) {
							this.itemLocal.citizenId = citizen.id;
						}
						return true;
					});
				}
			},
			'dropdowns.position.value': {
				handler() {
					if (this.dropdowns.value)
						return;
					this.dropdowns.position.items.map((position) => {
						if (position.id === this.dropdowns.position.value) {
							this.itemLocal.positionId = position.id;
						}
						return true;
					});
				}
			},


			'dropdowns.married.value': {
				handler() {
					// if (this.dropdowns.value)
					// 	return;
					this.dropdowns.married.items.map((marriage) => {
						if (marriage.id === this.dropdowns.married.value) {
							this.itemLocal.marriageStatusId = marriage.id;
						}
						return true;
					});
				}
			},
			currentPage: {
				handler() {
					this.fetchList();
				}
			},
			'getPagination': {
				handler() {
					if (this.getemployees.items < 1) {
						this.fetchList();

					}
				}
			}

		}
	}

</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style scoped lang="scss">
	#Departments {
		background-color: #ffffff;
		padding: 15px;
		min-height: 30rem;
	}


	label {
		margin-bottom: 0.2rem;
	}

	#departmentsTitle {
		margin: .7em .9em .8em 0;
		display: inline-block;
		border-bottom: 1px solid #ccc;
	}

	#addDepIcon {
		display: inline-block;
	}

	.treeColumn {
		margin-left: 3rem;
	}

	li div div, .add, .delete {
		display: inline-block;
		cursor: pointer;
		margin: 2px 0;
	}


	.lebeltop {
		font-size: 12px;
	}

	li div div {
		&:hover {
			text-decoration: underline;
		}
	}

	.top {
		margin-top: -12px;
	}

	li > .bold {
		font-weight: bold;
		display: inline-block;
	}

	ul:not(:first-child) {
		padding-left: 1.7em !important;
		line-height: 1.5em;
		list-style-type: none;
	}

	.card-header {
		padding-top: 5px;
	}

	ul:first-child {
		line-height: 1.5em;
		list-style-type: none;
	}

	.col9 {
		padding: 0px;
	}

	* {
		box-sizing: border-box;
	}

	#app {
		display: flex;
	}

	#aside {
		display: none;
		width: 200px;
		/*background: #cecece;*/
		height: 100vh;
	}

	#aside.active {
		display: block;
	}

	template {
		display: flex;
		white-space: nowrap;
	}

	.wrapper {
		display: flex;
		align-items: stretch;
		flex-direction: column;
		width: 100vw;
	}

	.modal .refModal .form-group label ~ div {
		width: 100%;
	}
</style>
